export default "__VITE_ASSET__B3qXDS5g__"